import uiRouter from 'angular-ui-router';

let mod = angular
  // This module is for any states that are used solely to redirect the user
  .module('app.redirect', [uiRouter])
  // Parent redirect state
  .config($stateProvider =>
    $stateProvider.state('app.redirect', { abstract: true })
  )
  .config($stateProvider =>
    $stateProvider.state('app.redirect.agent', {
      url: '/agent/signup',
      resolve: {
        protocol($location) {
          return $location.protocol();
        },
        host($location) {
          return $location.host();
        },
        params($location) {
          return $location.search();
        },
        guard($window, protocol, host, params) {
          return ($window.location = `${protocol}://${host}/agents/welcome?${$.param(
            params
          )}`);
        },
      },
    })
  )
  .controller('RedirectController', function($state, agent) {
    // If, for some reason, the user makes it here... redirect to the welcome page
    $state.go('app.welcome');
  });

export default mod;
